import {Grid} from 'src/design/atoms/Grid';
import {
  IconCertificate,
  IconClock,
  IconId,
  IconRepeat,
} from '@tabler/icons-react';
import React from 'react';
import {SectionCard} from 'src/design/atoms/SectionCard';
import {ProactField} from 'src/app/forms/engine/ProactField';
import {CourseSettingsFieldGroups} from 'src/app/training/courseFormMeta';

const groupIcons: Record<string, React.ReactNode> = {
  Identity: <IconId size={16} />,
  Deadlines: <IconClock size={16} />,
  Attempts: <IconRepeat size={16} />,
  Certificate: <IconCertificate size={16} />,
};

export const courseSettingsGroupAnchorId = (group: string): string =>
  `course-settings-group-${group.toLowerCase()}`;

export interface CourseSettingsPanelProps {
  disabled?: boolean;
  /** Rendered as an extra card alongside the field groups. */
  extraCard?: React.ReactNode;
}

/**
 * Body of the course settings header section: the course-level fields grouped
 * into Identity / Deadlines / Attempts / Certificate cards. Renders against
 * the same form instance the workspace's single Save submits — fields are
 * looked up from the `ProactForm` context by name, so grouping is
 * presentation-only.
 *
 * Group cards carry anchor ids so the collapsed summary chips can expand the
 * section and scroll to the group they describe.
 */
export const CourseSettingsPanel: React.FC<CourseSettingsPanelProps> = ({
  disabled,
  extraCard,
}) => {
  return (
    <fieldset
      disabled={disabled}
      style={{border: 'none', padding: 0, margin: 0}}>
      <Grid gutter="md">
        {CourseSettingsFieldGroups.map(group => (
          <Grid.Col
            key={group.title}
            id={courseSettingsGroupAnchorId(group.title)}
            span={{base: 12, sm: 6, lg: 4}}>
            <SectionCard
              title={group.title}
              icon={groupIcons[group.title]}
              h="100%">
              <Grid p="md" gutter="md">
                {group.fields.map(name => (
                  <ProactField key={name} name={name} />
                ))}
              </Grid>
            </SectionCard>
          </Grid.Col>
        ))}
        {extraCard && (
          <Grid.Col span={{base: 12, sm: 6, lg: 4}}>{extraCard}</Grid.Col>
        )}
      </Grid>
    </fieldset>
  );
};
